var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 57,
    viewBox: "0 0 60 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9996 9.45992L35.5196 20.6199L36.4396 22.6199L38.4396 22.9199L50.7596 24.6999L41.9996 33.2999L40.4996 34.7599L40.8596 36.7599L42.9596 49.0199L31.9396 43.2399L29.9996 42.4199L28.1396 43.3999L17.1196 49.0999L19.1196 36.8399L19.4796 34.8399L17.9996 33.2999L9.15957 24.5999L21.4796 22.8199L23.4796 22.5199L24.3996 20.5199L29.9996 9.45992ZM29.9996 0.419922L20.8996 18.8599L0.55957 21.7999L15.2796 36.1599L11.7996 56.4199L29.9996 46.8599L48.1996 56.4199L44.7196 36.1599L59.4396 21.8199L39.0996 18.8599L29.9996 0.419922Z",
    fill: "#D6DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.16fb8fe76a0fd64264355b94bc2d332e.svg";
export { ForwardRef as ReactComponent };